(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('trusted', trustedUrl)

    function trustedUrl($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }
}());